import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';

export default function P() {
    const { t } = useLang('bkw');
    return (
        <div id="bkw-P" className={`bkw-P bkw-box ${css['bkw-P']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">{t('P_title')}</h2>
            </div>
            <div className="img-box">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1738984031624/16.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1738984031435/16_Pad.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1738984031300/16_M.png"
                />
            </div>
        </div>
    );
}
